import { useSearchParams } from 'react-router-dom';
import { verifyRequest } from '../api';
import { storeAmplifyTokens } from 'utils/amplifyTokenStorage';
import { useEffect, useState } from 'react';
import { Box, CircularProgress, Container } from '@mui/material';
import { Typography } from '@cfra-nextgen-frontend/shared';

type VerifyState = 'loading' | 'error';

export function VerifyToken() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') ?? '';
    const [status, setStatus] = useState<VerifyState>('loading');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (!token) {
            setStatus('error');
            setErrorMessage('Invalid sign-in link. Please request a new one.');
            return;
        }

        verifyRequest(token)
            .then((response) => {
                storeAmplifyTokens(response);
                window.location.href = '/chart-reader';
            })
            .catch(() => {
                setStatus('error');
                setErrorMessage('This link is invalid or has expired. Please request a new sign-in link.');
            });
    }, [token]);

    if (status === 'error') {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                <Container
                    maxWidth={false}
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        py: 4,
                    }}>
                    <Typography variant='body1' color='error'>
                        {errorMessage}
                    </Typography>
                    <a href='/login'>Return to sign-in</a>
                </Container>
            </Box>
        );
    }

    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                <Container
                    maxWidth={false}
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        py: 4,
                    }}>
                    <CircularProgress />
                    <Typography variant='body1' sx={{ color: '#002B5A', mb: 2 }}>
                        Verifying user...
                    </Typography>
                </Container>
            </Box>
        </>
    );
}
